import { render } from "./EmbedSnippet.vue?vue&type=template&id=6bdb7854&scoped=true"
import script from "./EmbedSnippet.vue?vue&type=script&lang=js"
export * from "./EmbedSnippet.vue?vue&type=script&lang=js"

import "./EmbedSnippet.vue?vue&type=style&index=0&id=6bdb7854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdb7854"]])

export default __exports__